import { useTranslation } from 'react-i18next';
import { Loader } from 'components/Loader';
import { Paragraph } from 'components/Typography';
import { withSignupMachineState } from 'domains/signup/signupFlow/context/signupContext';
import { withScheduleMachineState } from 'domains/signup/consultationSchedule/data/ScheduleContext';
import { withScreenerMachineState } from 'domains/signup/screener/context/screenerContext';

const Loading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="h-full flex flex-col justify-center items-center">
      <Loader
        iconClassName="w-40 h-40 text-primary-500"
        className="m-16
      "
      />
      <Paragraph className="text-center">{t('signup.direct.steps.loading')}</Paragraph>
    </div>
  );
};

export const ScheduleLoadingStep = withScheduleMachineState(Loading, ['loadingAvailableDates']);

export const SignupLoadingStep = withSignupMachineState(Loading, ['creatingLead', 'schedulingConsultation']);

export const ScreenerLoadingStep = withScreenerMachineState(Loading, 'finished');
